import React, { useState } from 'react';
import { Box, Typography, Grid, Paper } from '@mui/material';
import { FormTextField } from '../../../components/common/Form/FormTextField';
import { FormTextArea } from '../../../components/common/Form/FormTextArea';
import { FormDropDown } from '../../../components/common/Form/FormDropdown';
import { FormDatePicker } from '../../../components/common/Form/FormDatePicker';
import { FormTimePicker } from '../../../components/common/Form/FormTimePicker';
import { FormDateTimePicker } from '../../../components/common/Form/FormDateTimePicker';
import { useForm, FormProvider } from 'react-hook-form';
import { FormControlledPhoneField } from '../../../components/common/Form/FormPhoneField';

export default function FormFieldsTest() {
  const [title, setTitle] = useState('Test title');
  const [description, setDescription] = useState('Test description');
  const [severity, setSeverity] = useState('default');
  const [date, setDate] = useState(null);
  const [time, setTime] = useState(null);
  const [dateTime, setDateTime] = useState(null);

  const methods = useForm({
    defaultValues: {
      contactPhone: { countryCode: 1, number: '', voiceOnly: 'mobile' },
      contactPhone2: { countryCode: 1, number: '', voiceOnly: 'mobile' },
      contactPhone3: { countryCode: 1, number: '', voiceOnly: 'mobile' },
    },
  });

  const onSubmit = (data) => {
    // eslint-disable-next-line no-console
    console.log('Phone form submit', data);
    alert('Submitted: ' + JSON.stringify(data));
  };

  const dropdownOptions = [
    { label: 'Default', value: 'default' },
    { label: 'Emergency', value: 'emergency' },
    { label: 'Warning', value: 'warning' },
  ];

  return (
    <Box sx={{ p: 2 }}>
      <Typography component="h2">Form Fields Test</Typography>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormTextField
            id="dev__title"
            label="Input with out gridProps"
            value={title}
            onChange={(v) => setTitle(v)}
            labelGridProps={{ xs: 12 }}
            inputGridProps={{ xs: 12 }}
          />
          <FormTextField
            id="dev__title2"
            label="input with gridProps"
            value={title}
            onChange={(v) => setTitle(v)}
            labelGridProps={{ xs: 12 }}
            inputGridProps={{ xs: 12 }}
            gridProps={{ spacing: { xs: 0, sm: 1 } }}
          />
          <FormTextField
            id="dev__title3"
            label="input with diff gridProps"
            value={title}
            onChange={(v) => setTitle(v)}
            labelGridProps={{ xs: 12 }}
            inputGridProps={{ xs: 12 }}
            gridProps={{ spacing: 3 }}
          />
        </Grid>

        <Grid item xs={12}>
          <FormTextArea
            id="dev__description"
            label="textArea without gridProps"
            value={description}
            onChange={(v) => setDescription(v)}
            labelGridProps={{ xs: 12 }}
            inputGridProps={{ xs: 12 }}
          />
          <FormTextArea
            id="dev__description2"
            label="textArea with gridProps"
            value={description}
            onChange={(v) => setDescription(v)}
            labelGridProps={{ xs: 12 }}
            inputGridProps={{ xs: 12 }}
            gridProps={{ spacing: { xs: 0, sm: 1 } }}
          />
          <FormTextArea
            id="dev__description3"
            label="textArea with gridProps"
            value={description}
            onChange={(v) => setDescription(v)}
            labelGridProps={{ xs: 12 }}
            inputGridProps={{ xs: 12 }}
            gridProps={{ spacing: 3 }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormDropDown
            id="dev__severity"
            label="drop down with out gridProps"
            options={dropdownOptions}
            value={severity}
            onChange={(e) => setSeverity(e.target.value)}
            labelGridProps={{ xs: 12 }}
            inputGridProps={{ xs: 12 }}
          />
          <FormDropDown
            id="dev__severity2"
            label="drop down with gridProps"
            options={dropdownOptions}
            value={severity}
            onChange={(e) => setSeverity(e.target.value)}
            labelGridProps={{ xs: 12 }}
            inputGridProps={{ xs: 12 }}
            gridProps={{ spacing: { xs: 0, sm: 1 } }}
          />
          <FormDropDown
            id="dev__severity3"
            label="drop down with diff gridProps"
            options={dropdownOptions}
            value={severity}
            onChange={(e) => setSeverity(e.target.value)}
            labelGridProps={{ xs: 12 }}
            inputGridProps={{ xs: 12 }}
            gridProps={{ spacing: 3 }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormDatePicker
            id="dev__date"
            label="date with out gridProps"
            value={date}
            onChange={(v) => setDate(v)}
            labelGridProps={{ xs: 12 }}
            inputGridProps={{ xs: 12 }}
          />
          <FormDatePicker
            id="dev__date2"
            label="date with gridProps"
            value={date}
            onChange={(v) => setDate(v)}
            labelGridProps={{ xs: 12 }}
            inputGridProps={{ xs: 12 }}
            gridProps={{ spacing: { xs: 0, sm: 1 } }}
          />
          <FormDatePicker
            id="dev__date2"
            label="date with diff gridProps"
            value={date}
            onChange={(v) => setDate(v)}
            labelGridProps={{ xs: 12 }}
            inputGridProps={{ xs: 12 }}
            gridProps={{ spacing: 3 }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormTimePicker
            id="dev__time"
            label="time with out gridProps"
            value={time}
            onChange={(v) => setTime(v)}
            labelGridProps={{ xs: 12 }}
            inputGridProps={{ xs: 12 }}
          />
          <FormTimePicker
            id="dev__time2"
            label="time with gridProps"
            value={time}
            onChange={(v) => setTime(v)}
            labelGridProps={{ xs: 12 }}
            inputGridProps={{ xs: 12 }}
            gridProps={{ spacing: { xs: 0, sm: 1 } }}
          />
          <FormTimePicker
            id="dev__time3"
            label="time with diff gridProps"
            value={time}
            onChange={(v) => setTime(v)}
            labelGridProps={{ xs: 12 }}
            inputGridProps={{ xs: 12 }}
            gridProps={{ spacing: 3 }}
          />

          <FormDateTimePicker
            id="dev__datetime"
            label="date time without gridProps"
            value={dateTime}
            onChange={(v) => setDateTime(v)}
            labelGridProps={{ xs: 12 }}
            inputGridProps={{ xs: 12 }}
          />

          <FormDateTimePicker
            id="dev__datetime2"
            label="date time with gridProps"
            value={dateTime}
            onChange={(v) => setDateTime(v)}
            labelGridProps={{ xs: 12 }}
            inputGridProps={{ xs: 12 }}
            gridProps={{ spacing: { xs: 0, sm: 1 } }}
          />

          <FormDateTimePicker
            id="dev__datetime3"
            label="date time with diff gridProps"
            value={dateTime}
            onChange={(v) => setDateTime(v)}
            labelGridProps={{ xs: 12 }}
            inputGridProps={{ xs: 12 }}
            gridProps={{ spacing: 3 }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(onSubmit)}>
              <FormControlledPhoneField
                control={methods.control}
                name="contactPhone"
                label="phone with no gridProps"
                required
                showPhoneTypeInput={true}
                showPhoneCountryCodeInput={true}
                labelGridProps={{ xs: 12 }}
                inputContainerGridProps={{ xs: 12 }}
              />

              <FormControlledPhoneField
                control={methods.control}
                name="contactPhone2"
                label="phone with gridProps"
                required
                showPhoneTypeInput={true}
                showPhoneCountryCodeInput={true}
                labelGridProps={{ xs: 12 }}
                inputContainerGridProps={{ xs: 12 }}
                gridProps={{ spacing: { xs: 0, sm: 1 } }}
              />

              <FormControlledPhoneField
                control={methods.control}
                name="contactPhone3"
                label="phone with diff gridProps"
                required
                showPhoneTypeInput={true}
                showPhoneCountryCodeInput={true}
                labelGridProps={{ xs: 12 }}
                inputContainerGridProps={{ xs: 12 }}
                gridProps={{ spacing: 3 }}
              />

              <Box sx={{ mt: 1 }}>
                <button type="submit" className="myOdu__button">
                  Submit Phones
                </button>
              </Box>
            </form>
          </FormProvider>
        </Grid>
      </Grid>
    </Box>
  );
}
